import { Box } from '@mui/material';

import Iconify from 'src/components/iconify';

interface AiFeatureLabelProps {
  label: string;
}

export default function AiFeatureLabel({ label }: AiFeatureLabelProps): JSX.Element {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {label}
      <Iconify icon="solar:stars-bold" width={16} aria-hidden sx={{ color: 'primary.main' }} />
    </Box>
  );
}
